import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#4283FF",
        secondary: "#3BC8C1"
      },
      dark: {
        primary: "#4283FF",
        secondary: "#3BC8C1"
      }
    }
  },
  iconfont: "mdi"
};

export default new Vuetify(opts);
